import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import api from "@/lib/api";
import { BookOpen, Clock, Target, ArrowRight, Search } from "lucide-react";

export default function ExamList() {
  const [exams, setExams] = useState([]);
  const [attempts, setAttempts] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/exams").then((r) => setExams(r.data));
    api.get("/attempts/mine").then((r) => setAttempts(r.data));
  }, []);

  const submittedIds = new Set(
    attempts.filter((a) => a.status === "submitted").map((a) => a.exam_id)
  );

  const filtered = exams.filter(
    (e) =>
      e.title.toLowerCase().includes(q.toLowerCase()) ||
      (e.subject || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <AppShell title="Available exams" subtitle="Pick one and start when you're ready.">
      <div className="mb-6 relative max-w-md">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by title or subject…"
          className="w-full bg-white border border-slate-200 rounded-xl pl-9 pr-4 py-2.5 focus:ring-2 focus:ring-indigo-500 outline-none"
          data-testid="exam-search-input"
        />
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="exam-list">
        {filtered.map((e) => {
          const done = submittedIds.has(e.id);
          return (
            <div key={e.id} className="qs-card p-5" data-testid={`exam-card-${e.id}`}>
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 rounded-xl bg-indigo-50 text-indigo-600 grid place-items-center">
                  <BookOpen className="w-5 h-5" />
                </div>
                {done && (
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700">
                    Completed
                  </span>
                )}
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-slate-900">{e.title}</h3>
              <p className="text-sm text-slate-500 line-clamp-2">{e.description}</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-slate-500">
                <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {e.duration_min}m</span>
                <span className="inline-flex items-center gap-1"><Target className="w-3.5 h-3.5" /> {e.passing_score}% pass</span>
                <span>{e.questions?.length || 0} Q</span>
              </div>
              <div className="mt-5">
                <Link
                  to={`/exam/${e.id}`}
                  className={done ? "btn-ghost text-sm w-full justify-center" : "btn-primary text-sm w-full justify-center"}
                  data-testid={`exam-card-start-${e.id}`}
                >
                  {done ? "Retake" : "Start exam"} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          );
        })}
        {filtered.length === 0 && (
          <div className="col-span-full text-center text-slate-500 py-16" data-testid="no-exams-found">
            No exams match your search.
          </div>
        )}
      </div>
    </AppShell>
  );
}
